import { siteInfo } from '@/mocks/homepage';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading text-foreground-900">{siteInfo.name}</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed mb-4 max-w-xs">
              哔咔动漫是国内领先的漫画追更推荐平台，提供追更漫画实时连载更新、好看的漫画推荐与热门排行，让哔咔动漫追番不停，找到你最想追的热门作品。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">专题索引</a></li>
              <li><a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">热门排行</a></li>
              <li><a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">常见问答</a></li>
              <li><a href="#comments" onClick={(e) => handleNavClick(e, '#comments')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">读者评论</a></li>
              <li><a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">App 下载</a></li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li><span className="text-xs text-foreground-500">投稿合作：contact@pikaanime.com</span></li>
              <li><span className="text-xs text-foreground-500">微博：@哔咔动漫官方</span></li>
              <li><span className="text-xs text-foreground-500">微信：pika_anime_official</span></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-[11px] text-foreground-400">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">用户协议</a>
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}